// import Dotdigital from '@scandipwa/page-builder/src/component/DotdigitalForm';

import CmsBlock from 'Component/CmsBlock';
import {
    NewsletterSubscription as SourceNewsletterSubscription
} from 'SourceComponent/NewsletterSubscription/NewsletterSubscription.component';

import './NewsletterSubscription.override.style';

/** @namespace Bodypwa/Component/NewsletterSubscription/Component */
export class NewsletterSubscriptionComponent extends SourceNewsletterSubscription {
    renderActions() {
        return (
            <button
              type="submit"
              block="Button"
              className="NewsletterButton"
              mods={ { isHollow: true } }
              aria-label={ __('Submit') }
            >
                <span className="icon-arrow_right_icon" />
            </button>
        );
    }

    render() {
        return (
            <div block="NewsletterSubscription" id="dotDigitalContainer">
                <CmsBlock identifier="footer_newsletter_block" />
            </div>
        );
    }
}

export default NewsletterSubscriptionComponent;
